<div>
    <div class="table-container audit-table">
        <div class="between-center">
            <p class="table-breadcrumb">
                {{ totalPaginatedItems }}
                Results
            </p>
            <div class="end-center">
                <input
                    type="checkbox"
                    [checked]="cloudProcessEnabled"
                    class="info-box-checkbox table-checkbox"
                    (click)="toggleCloudProcess()"
                />
                <p>Show Cloud Processes</p>
            </div>
        </div>

        <div [ngStyle]="{ display: isGrouped ? 'none' : 'block' }">
            <table
                class="custom-table log-table"
                customSort
                (sortChange)="onSortChange($event)"
                [ngStyle]="{
                    'min-height': dataSource.data.length === 0 ? '300px' : 'auto',
                }"
            >
                <thead>
                    <tr>
                        <th custom-sort-header="date">
                            <p class="table-header">Date & Time</p>
                        </th>
                        <th custom-sort-header="user">
                            <p class="table-header">User</p>
                        </th>
                        <th custom-sort-header="activity">
                            <p class="table-header">Activity</p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                <tr *ngFor="let log of dataSource.renderedData">
                    <td>
                        <p class="table-cell">
                            {{ log.date | date: "dd/MM/yyyy HH:mm:ss" }}
                        </p>
                    </td>
                    <td class="user-td">
                        <div class="between-center">
                            <div
                                [ngClass]="{
                                    'tooltip-wrapper': isOverflowed(userRef),
                                }"
                                style="width: 100%"
                            >
                                <p
                                    #userRef
                                    class="table-cell user-cell"
                                    [ngStyle]="{
                                        'font-weight':
                                            log.user === 'Unknown'
                                                ? '400'
                                                : '600',
                                    }"
                                >
                                    {{
                                        log.user === "Unknown"
                                            ? "Cloud Process"
                                            : log.user
                                    }}
                                </p>
                                <div class="tooltip-text">
                                    <p
                                        [ngStyle]="{
                                            'font-weight':
                                                log.user === 'Unknown'
                                                    ? '400'
                                                    : '600',
                                        }"
                                    >
                                        {{
                                            log.user === "Unknown"
                                                ? "Cloud Process"
                                                : log.user
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td class="activity-td">
                        <div class="start-center">
                            <p
                                class="activity-chip"
                                [ngStyle]="{
                                    'background-color': log.activity.color,
                                }"
                            >
                                {{ log.activity.activity }}
                            </p>
                            <div
                                [ngClass]="{
                                    'tooltip-wrapper':
                                        isOverflowed(activityRef),
                                }"
                            >
                                <p
                                    #activityRef
                                    class="table-cell activity-detail"
                                >
                                    [
                                    <span>{{ log.activity.caption }}</span>
                                    <span
                                        *ngIf="log.activity?.redirection?.text"
                                    >
                                        {{ readableNavigationFormat(log) }} |
                                    </span>
                                    <span
                                        *ngIf="log.activity?.redirection?.text"
                                        [ngClass]="{
                                            'activity-url':
                                                log.activity.redirection.link,
                                        }"
                                        (click)="openUrl(log)"
                                    >
                                        {{
                                            readableLink(
                                                log.activity?.redirection?.text
                                            )
                                        }}
                                    </span>
                                    <span
                                        *ngIf="
                                            log.activity?.redirection?.duration
                                        "
                                    >
                                        |
                                    </span>
                                    <span
                                        *ngIf="
                                            log.activity?.redirection?.duration
                                        "
                                    >
                                        {{
                                            log.activity?.redirection?.duration
                                        }}
                                        mins
                                    </span>
                                    ]
                                </p>
                                <div class="tooltip-text">
                                    [
                                    <span>{{ log.activity.caption }}</span>
                                    <span
                                        *ngIf="log.activity?.redirection?.text"
                                    >
                                        |
                                    </span>
                                    <span
                                        *ngIf="log.activity?.redirection?.text"
                                        [ngClass]="{
                                            'activity-url':
                                                log.activity.redirection.link,
                                        }"
                                        (click)="openUrl(log)"
                                    >
                                        {{ log.activity?.redirection?.text }}
                                    </span>
                                    <span
                                        *ngIf="
                                            log.activity?.redirection?.duration
                                        "
                                    >
                                        |
                                    </span>
                                    <span
                                        *ngIf="
                                            log.activity?.redirection?.duration
                                        "
                                    >
                                        {{
                                            log.activity?.redirection?.duration
                                        }}
                                        mins
                                    </span>
                                    ]
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <!-- GROUPED TABLE -->
        <div [ngStyle]="{ display: !isGrouped ? 'none' : 'block' }">
            <table class="custom-table log-table">
                <colgroup>
                    <col style="width: 20%" />
                    <col style="width: 25%" />
                    <col style="width: 55%" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <p class="table-header">Date & Time</p>
                        </th>
                        <th>
                            <p class="table-header">User</p>
                        </th>
                        <th>
                            <p class="table-header">Activity</p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                <ng-container *ngFor="let row of groupedTableDataSource.renderedData">
                <!-- Group Header Row -->
                <tr *ngIf="row.isGroup; else logRow" class="group-row">
                    <td
                        [attr.colspan]="displayedColumns.length"
                        class="group-header pointer"
                        (click)="toggleGroup(row.groupId)"
                    >
                        <div class="between-center">
                            <p class="table-header">
                                {{
                                    row.user.fullname === "Unknown"
                                        ? "Cloud Process"
                                        : row.user.fullname
                                }}

                                [ Session
                                {{
                                    row.startDate | date: "dd/MM/yyyy HH:mm:ss"
                                }}
                                ]
                            </p>
                            <div class="center expand-button">
                                <div
                                    [ngClass]="
                                        row.expanded
                                            ? 'triangle-down'
                                            : 'triangle-right'
                                    "
                                ></div>
                            </div>
                        </div>
                    </td>
                </tr>
                <ng-template #logRow>
                <tr>
                    <td>
                        <p class="table-cell">
                            {{ row.log?.date | date: "dd/MM/yyyy | HH:mm:ss" }}
                        </p>
                    </td>
                    <td class="user-td">
                        <div class="between-center">
                            <div
                                [ngClass]="{
                                    'tooltip-wrapper': isOverflowed(userRef),
                                }"
                                style="width: 100%"
                            >
                                <p
                                    #userRef
                                    class="table-cell user-cell"
                                    [ngStyle]="{
                                        'font-weight':
                                            row.log?.user === 'Unknown'
                                                ? '400'
                                                : '600',
                                    }"
                                >
                                    {{
                                        row.log?.user === "Unknown"
                                            ? "Cloud Process"
                                            : row.log?.user
                                    }}
                                </p>
                                <div class="tooltip-text">
                                    <p
                                        [ngStyle]="{
                                            'font-weight':
                                                row.log?.user === 'Unknown'
                                                    ? '400'
                                                    : '600',
                                        }"
                                    >
                                        {{
                                            row.log?.user === "Unknown"
                                                ? "Cloud Process"
                                                : row.log?.user
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td class="activity-td">
                        <div class="start-center" *ngIf="!row.isGroup">
                            <p
                                class="activity-chip"
                                [ngStyle]="{
                                    'background-color': row.log.activity.color,
                                }"
                            >
                                {{ row.log.activity.activity }}
                            </p>
                            <div
                                [ngClass]="{
                                    'tooltip-wrapper':
                                        isOverflowed(activityRef),
                                }"
                            >
                                <p
                                    class="table-cell activity-detail"
                                    #activityRef
                                >
                                    [ {{ row.log.activity.caption }}
                                    <span
                                        *ngIf="
                                            row.log.activity?.redirection?.text
                                        "
                                        [ngClass]="{
                                            'activity-url':
                                                row.log.activity.redirection
                                                    .link,
                                        }"
                                        (click)="openUrl(row)"
                                    >
                                        |
                                        {{
                                            row.log.activity?.redirection?.text
                                        }}</span
                                    >
                                    <span
                                        *ngIf="
                                            row.log.activity?.redirection
                                                ?.duration
                                        "
                                    >
                                        |
                                        {{
                                            row.log.activity?.redirection
                                                ?.duration
                                        }}</span
                                    >
                                    ]
                                </p>
                                <div class="tooltip-text">
                                    [ {{ row.log.activity.caption }}
                                    <span
                                        *ngIf="
                                            row.log.activity?.redirection?.text
                                        "
                                        [ngClass]="{
                                            'activity-url':
                                                row.log.activity.redirection
                                                    .link,
                                        }"
                                        (click)="openUrl(row)"
                                    >
                                        |
                                        {{
                                            row.log.activity?.redirection?.text
                                        }}</span
                                    >
                                    <span
                                        *ngIf="
                                            row.log.activity?.redirection
                                                ?.duration
                                        "
                                    >
                                        |
                                        {{
                                            row.log.activity?.redirection
                                                ?.duration
                                        }}</span
                                    >
                                    ]
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                </ng-template>
                </ng-container>
                </tbody>
            </table>
        </div>

        <div *ngIf="dataSource.data.length === 0" class="no-data center">
            <p class="no-data-text">
                No activity recorded for this user(s) in this period.
            </p>
        </div>

        <custom-paginator
            [length]="activeDataSource.filteredData.length"
            [pageSize]="pageSize"
            [pageIndex]="activeDataSource.pageIndex"
            [pageSizeOptions]="[5, 10, 25, 50, 100]"
            (page)="onPageChange($event)"
        ></custom-paginator>
    </div>
</div>
